import { render } from "./ObservatoryTypeSwitch.vue?vue&type=template&id=1efa67ee"
import script from "./ObservatoryTypeSwitch.vue?vue&type=script&lang=js"
export * from "./ObservatoryTypeSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__